(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pda-scale-calculator"] && !Shopify.designMode) return;
  try {
    


if (!customElements.get('pda-scale-calculator')) {
customElements.define('pda-scale-calculator', class extends HTMLElement {
connectedCallback(){
if(this.ready)return;
if(!this.querySelector('[data-from]')){requestAnimationFrame(()=>this.connectedCallback());return;}
this.ready=true;
this.addEventListener('input',()=>this.update());
this.addEventListener('change',()=>this.update());
this.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;
if(b.matches('.psc-swap')){const a=this.querySelector('[data-from]'),z=this.querySelector('[data-to]');[a.value,z.value]=[z.value,a.value];const ca=this.querySelector('[data-custom-from]'),cz=this.querySelector('[data-custom-to]');[ca.value,cz.value]=[cz.value,ca.value];}this.update();});this.update();}
format(n){return n!==0&&(Math.abs(n)<0.0001||Math.abs(n)>=1e9)?n.toExponential(4):new Intl.NumberFormat('en',{maximumFractionDigits:4}).format(n);}
update(){
const q=s=>this.querySelector(s),a=q('[data-from]'),b=q('[data-to]'),x=Number(a.value==='custom'?q('[data-custom-from]').value:a.value),y=Number(b.value==='custom'?q('[data-custom-to]').value:b.value),f=x/y,valid=x>0&&y>0&&Number.isFinite(x)&&Number.isFinite(y)&&Number.isFinite(f)&&f>0&&Number.isFinite(f*100);
['from','to'].forEach(side=>{const sel=q('[data-'+side+']'),input=q('[data-custom-'+side+']');input.parentElement.hidden=sel.value!=='custom';input.setAttribute('aria-invalid',String(!(Number(input.value)>0&&Number.isFinite(Number(input.value)))));});
q('[data-percent]').textContent=valid?this.format(f*100)+'%':'…';
q('[data-direction]').textContent=valid?(f>1?this.dataset.enlarge:f<1?this.dataset.reduce:this.dataset.same):'';
q('[data-factor]').textContent=valid?'1:'+this.format(x)+' → 1:'+this.format(y)+'   /   ×'+this.format(f):'';
const len=q('[data-length]'),n=Number(len.value),unit=q('[data-unit]').value,units={mm:0.1,cm:1,m:100,in:2.54,ft:30.48},real=n*units[unit]*x,next=real/y;
const lv=n>0&&Number.isFinite(real)&&Number.isFinite(next)&&real>0&&next>0;
len.setAttribute('aria-invalid',String(!(n>0&&Number.isFinite(n))));
const imperial=cm=>{let total=Math.round(cm/2.54*100)/100;const feet=Math.floor(total/12),inches=Math.round((total-feet*12)*100)/100;return this.format(feet)+' ft '+(cm>0&&total===0?'<0.01':this.format(inches))+' in';};
q('[data-real-cm]').textContent=valid&&lv?this.format(real)+' cm':'…';
q('[data-real-m]').textContent=valid&&lv?this.format(real/100)+' m':'';
q('[data-real-imperial]').textContent=valid&&lv?'≈ '+imperial(real):'';
q('[data-new-cm]').textContent=valid&&lv?this.format(next)+' cm':'…';
q('[data-new-imperial]').textContent=valid&&lv?'≈ '+imperial(next):'';
q('[data-length-result]').textContent=valid&&lv&&unit!=='cm'?this.format(next/units[unit])+' '+unit:'';
q('[data-error-message]').textContent=!valid?this.dataset.error:!lv?this.dataset.lengtherror:'';

}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-stair-calculator"] && !Shopify.designMode) return;
  try {
    
(()=>{
function initialize(root){
if(root.dataset.ready==='true')return;root.dataset.ready='true';

const translationRecords=JSON.parse(root.querySelector('[data-translations]').textContent);
const exact=new Map(translationRecords.map(r=>[r.source,r.value]));
const patterns=translationRecords.filter(r=>/\{\w+\}/.test(r.source)).map(r=>{
 const names=[],escape=x=>x.replace(/[.*+?^$()|[\]\\]/g,'\\$&');
 let cursor=0,pattern='';for(const match of r.source.matchAll(/\{(\w+)\}/g)){pattern+=escape(r.source.slice(cursor,match.index))+'(.+?)';names.push(match[1]);cursor=match.index+match[0].length;}pattern+=escape(r.source.slice(cursor));
 return {...r,names,regex:new RegExp('^'+pattern+'$')};
});
function trText(value,depth=0){
 const source=String(value);if(exact.has(source))return exact.get(source);if(depth>3)return source;
 for(const p of patterns){const match=source.match(p.regex);if(match)return p.value.replace(/\{(\w+)\}/g,(_,name)=>trText(match[p.names.indexOf(name)+1]??'',depth+1));}
 if(source.includes(' · '))return source.split(' · ').map(x=>trText(x,depth+1)).join(' · ');
 if(source.includes('. '))return source.split(/(?<=\.) /).map(x=>trText(x,depth+1)).join(' ');
 return source;
}
function translateRendered(){
 const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);let node;
 while((node=walker.nextNode())){if(node.parentElement.closest('script,style'))continue;const content=node.nodeValue,trim=content.trim();if(trim)node.nodeValue=content.replace(trim,trText(trim));}
 root.querySelectorAll('[aria-label],[title]').forEach(e=>{for(const attr of ['aria-label','title'])if(e.hasAttribute(attr))e.setAttribute(attr,trText(e.getAttribute(attr)));});
}
function render(force=false){renderBase(force);translateRendered();}

const DEFAULT={height:2800,width:1000,shape:'straight',unit:'mm',n:null,going:null,landing:null,split:null,gap:100,flip:false,fit:false,availableLength:4500,availableWidth:2500};
const FACTOR={mm:1,cm:10,in:25.4};
function suggestCount(height,shape='straight'){return Math.max(shape==='straight'?2:4,Math.round(height/175));}
function calculate(s){
 const errors=[];
 if(!Number.isFinite(s.height)||s.height<300||s.height>10000)errors.push('Enter a floor height between 300 and 10,000 mm.');
 if(!Number.isFinite(s.width)||s.width<300||s.width>5000)errors.push('Enter a stair width between 300 and 5,000 mm.');
 if(!['straight','l','u'].includes(s.shape))errors.push('Choose a stair shape.');
 const n=s.n??suggestCount(s.height,s.shape), min=s.shape==='straight'?2:4;
 if(!Number.isInteger(n)||n<min||n>80)errors.push(`Use ${min} to 80 whole risers.`);
 const rise=s.height/n,going=s.going??630-2*rise,landing=s.landing??s.width;
 if(!Number.isFinite(going)||going<100||going>600)errors.push('Use a going between 100 and 600 mm, or change the riser count.');
 if(s.shape!=='straight'&&(!Number.isFinite(landing)||landing<s.width||landing>6000))errors.push('Landing depth must be at least the entered stair width for this layout.');
 if(s.shape==='u'&&(!Number.isFinite(s.gap)||s.gap<0||s.gap>3000))errors.push('Use a flight gap between 0 and 3,000 mm.');
 const n1=s.shape==='straight'?n:(s.split??Math.floor(n/2)),n2=s.shape==='straight'?0:n-n1;
 if(s.shape!=='straight'&&(!Number.isInteger(n1)||n1<2||n2<2))errors.push('Each flight needs at least two risers.');
 if(s.fit&&(!Number.isFinite(s.availableLength)||s.availableLength<=0||s.availableLength>100000||!Number.isFinite(s.availableWidth)||s.availableWidth<=0||s.availableWidth>100000))errors.push('Enter an available length and width above 0 and up to 100,000 mm.');
 if(errors.length)return {errors};
 const run1=(n1-1)*going,run2=n2?(n2-1)*going:0;
 const footprintX=s.shape==='straight'?s.width:s.shape==='l'?landing+run2:2*s.width+s.gap;
 const footprintY=s.shape==='straight'?run1:s.shape==='l'?run1+landing:Math.max(run1,run2)+landing;
 const excess=s.fit?{length:Math.max(0,footprintY-s.availableLength),width:Math.max(0,footprintX-s.availableWidth)}:null;
 const warnings=[];
 if(rise<150||rise>190)warnings.push('Rise is outside the suggested 150–190 mm design range.');
 if(going<250||going>350)warnings.push('Going is outside the suggested 250–350 mm design range.');
 return {errors:[],n,rise,going,landing:s.shape==='straight'?0:landing,n1,n2,run1,run2,footprintX,footprintY,angle:Math.atan(rise/going)*180/Math.PI,treads:n-(n2?2:1),proportion:2*rise+going,excess,warnings};
}
function alternatives(s){const base=suggestCount(s.height,s.shape);return [base-1,base,base+1].filter(n=>n>=(s.shape==='straight'?2:4)).map(n=>({...calculate({...s,n,split:null}),selected:s.n===n||s.n===null&&n===base}));}
function fmt(mm,unit='mm',digits){return (mm/FACTOR[unit]).toLocaleString('en-US',{maximumFractionDigits:digits??(unit==='mm'?1:2)});}

function geometry(s,m){
 const plan=[],section=[];
 const poly=(out,pts,layer='STAIR',fill=null)=>out.push({type:'poly',pts,layer,fill});
 const line=(out,a,b,layer='STAIR')=>poly(out,[a,b],layer);
 const rect=(out,x,y,w,h,layer='STAIR',fill=null)=>poly(out,[[x,y],[x+w,y],[x+w,y+h],[x,y+h],[x,y]],layer,fill);
 const label=(out,x,y,text,size=100,layer='LABEL')=>out.push({type:'text',x,y,text,size,layer});
 const arrow=(out,pts)=>{poly(out,pts,'UP');const b=pts.at(-1),a=pts.at(-2),t=Math.atan2(b[1]-a[1],b[0]-a[0]),h=105;line(out,[b[0]-h*Math.cos(t-.45),b[1]-h*Math.sin(t-.45)],b,'UP');line(out,b,[b[0]-h*Math.cos(t+.45),b[1]-h*Math.sin(t+.45)],'UP');};
 const W=s.width,G=m.going,D=m.landing,A=m.run1,B=m.run2;
 rect(plan,0,0,W,A);
 for(let i=1;i<m.n1-1;i++)line(plan,[0,i*G],[W,i*G]);
 if(s.shape==='straight')arrow(plan,[[W/2,G*.3],[W/2,A-G*.3]]);
 if(s.shape==='l'){
  rect(plan,0,A,D,D,'LANDING','#f7f7f7');rect(plan,D,A,B,W);
  for(let i=1;i<m.n2-1;i++)line(plan,[D+i*G,A],[D+i*G,A+W]);
  arrow(plan,[[W/2,G*.3],[W/2,A+W/2],[D+B-G*.3,A+W/2]]);
 }
 if(s.shape==='u'){
  rect(plan,0,A,2*W+s.gap,D,'LANDING','#f7f7f7');rect(plan,W+s.gap,A-B,W,B);
  for(let i=1;i<m.n2-1;i++)line(plan,[W+s.gap,A-i*G],[2*W+s.gap,A-i*G]);
  arrow(plan,[[W/2,G*.3],[W/2,A+D/2],[1.5*W+s.gap,A+D/2],[1.5*W+s.gap,A-B+G*.3]]);
 }
 const offset=s.shape==='u'?Math.max(0,B-A):0;
 for(const e of plan)for(const p of e.pts)p[1]+=offset;
 label(plan,W/2,-145+offset,'UP',95);
 if(s.flip)for(const e of plan){if(e.pts)e.pts.forEach(p=>p[0]=m.footprintX-p[0]);else e.x=m.footprintX-e.x;}
 if(s.fit)rect(plan,0,0,s.availableWidth,s.availableLength,'AVAILABLE',null);
 const dim=(out,a,b,text,vertical=false)=>{
  line(out,a,b,'DIM');for(const p of [a,b])line(out,[p[0]-(vertical?65:0),p[1]-(vertical?0:65)],[p[0]+(vertical?65:0),p[1]+(vertical?0:65)],'DIM');
  label(out,(a[0]+b[0])/2+(vertical?-(text.length*95*.29+100):0),(a[1]+b[1])/2+(vertical?0:130),text,95,'DIM');
 };
 dim(plan,[0,m.footprintY+270],[m.footprintX,m.footprintY+270],`${fmt(m.footprintX,s.unit)} ${s.unit}`);

 dim(plan,[-280,0],[-280,m.footprintY],`${fmt(m.footprintY,s.unit)} ${s.unit}`,true);
 let x=0,z=0,pts=[[0,0]];
 const flight=(n)=>{for(let i=0;i<n;i++){z-=m.rise;pts.push([x,z]);if(i<n-1){x+=G;pts.push([x,z]);}}};
 flight(m.n1);
 if(m.n2){x+=D;pts.push([x,z]);flight(m.n2);}
 poly(section,pts);line(section,[-300,0],[0,0]);line(section,[x,-s.height],[x+300,-s.height]);
 line(section,[0,-m.rise],[m.run1,-m.n1*m.rise],'PITCH');
 if(m.n2)line(section,[m.run1+D,-(m.n1+1)*m.rise],[x,-s.height],'PITCH');
 dim(section,[-350,0],[-350,-s.height],`${fmt(s.height,s.unit)} ${s.unit}`,true);
 dim(section,[0,260],[x,260],`${fmt(x,s.unit)} ${s.unit}${m.n2?' unfolded':''}`);
 return {plan,section};
}
function bounds(entities){let xs=[],ys=[];for(const e of entities){if(e.pts)e.pts.forEach(p=>{xs.push(p[0]);ys.push(p[1]);});else{const w=e.text.length*e.size*.29;xs.push(e.x-w,e.x+w);ys.push(e.y-e.size,e.y+e.size*.4);}}return {minX:Math.min(...xs)-100,maxX:Math.max(...xs)+100,minY:Math.min(...ys)-100,maxY:Math.max(...ys)+100};}


const esc=s=>String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&apos;'}[c]));
const number=n=>Number(n.toFixed(5));
const ascii=s=>String(s).replace(/×/g,'x').replace(/°/g,' deg').replace(/[–−—]/g,'-').replace(/[^\x20-\x7E]/g,'');
const style=layer=>({color:layer==='DIM'?'#737373':layer==='AVAILABLE'?'#949494':layer==='PITCH'?'#a4a4a4':'#000000',dash:layer==='AVAILABLE'?'7 5':layer==='PITCH'?'3 4':null});

function renderSVG(entities,title='Stair drawing'){
 const b=bounds(entities);
 return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${b.minX} ${b.minY} ${b.maxX-b.minX} ${b.maxY-b.minY}" role="img" aria-label="${esc(title)}"><title>${esc(title)}</title>${entities.map(e=>{
  const st=style(e.layer);
  if(e.type==='text')return `<text x="${e.x}" y="${e.y}" font-family="Montserrat, Arial, sans-serif" font-size="${e.size}" text-anchor="middle" fill="${st.color}">${esc(e.text)}</text>`;
  return `<polyline points="${e.pts.map(p=>p.join(',')).join(' ')}" fill="${e.fill||'none'}" stroke="${st.color}" stroke-width="${e.layer==='UP'?1.35:1}" stroke-linejoin="miter" vector-effect="non-scaling-stroke"${st.dash?` stroke-dasharray="${st.dash}"`:''}/>`;
 }).join('')}</svg>`;
}

function makeDXF(s,m,drawings){
 const pairs=[],p=(code,value)=>pairs.push(String(code),String(value));let handle=16;
 const identity=()=>p(5,(handle++).toString(16).toUpperCase());
 p(0,'SECTION');p(2,'HEADER');p(9,'$ACADVER');p(1,'AC1015');p(9,'$INSBASE');p(10,0);p(20,0);p(30,0);p(9,'$INSUNITS');p(70,4);p(9,'$MEASUREMENT');p(70,1);p(0,'ENDSEC');
 p(0,'SECTION');p(2,'TABLES');p(0,'TABLE');p(2,'LTYPE');identity();p(100,'AcDbSymbolTable');p(70,1);p(0,'LTYPE');identity();p(100,'AcDbSymbolTableRecord');p(100,'AcDbLinetypeTableRecord');p(2,'CONTINUOUS');p(70,0);p(3,'Solid line');p(72,65);p(73,0);p(40,0);p(0,'ENDTAB');
 p(0,'TABLE');p(2,'LAYER');identity();p(100,'AcDbSymbolTable');p(70,7);
 for(const [name,color] of [['STAIR',7],['LANDING',7],['UP',7],['DIM',8],['LABEL',7],['AVAILABLE',9],['PITCH',8]]){p(0,'LAYER');identity();p(100,'AcDbSymbolTableRecord');p(100,'AcDbLayerTableRecord');p(2,name);p(70,0);p(62,color);p(6,'CONTINUOUS');}
 p(0,'ENDTAB');p(0,'ENDSEC');p(0,'SECTION');p(2,'ENTITIES');
 const text=(label,x,y,size=100,layer='LABEL')=>{p(0,'TEXT');identity();p(100,'AcDbEntity');p(8,layer);p(100,'AcDbText');p(10,number(x));p(20,number(y));p(30,0);p(40,size);p(1,ascii(label));p(72,1);p(11,number(x));p(21,number(y));p(31,0);p(100,'AcDbText');p(73,0);};
 const draw=(entities,offX,offY)=>{for(const e of entities){if(e.type==='text'){text(e.text,e.x+offX,-e.y+offY,e.size,e.layer);continue;}for(let i=1;i<e.pts.length;i++){const a=e.pts[i-1],b=e.pts[i];p(0,'LINE');identity();p(100,'AcDbEntity');p(8,e.layer);p(100,'AcDbLine');p(10,number(a[0]+offX));p(20,number(-a[1]+offY));p(30,0);p(11,number(b[0]+offX));p(21,number(-b[1]+offY));p(31,0);}}};
 const bp=bounds(drawings.plan),bs=bounds(drawings.section),offsetX=bp.maxX-bs.minX+1500;
 draw(drawings.plan,0,0);draw(drawings.section,offsetX,0);
 text('PLAN / 1 drawing unit = 1 mm',m.footprintX/2,450,100);
 text(`${m.n2?'UNFOLDED SECTION':'SECTION'} / 1 drawing unit = 1 mm`,offsetX+(m.run1+m.run2+m.landing)/2,s.height+450,100);
 text(`Studio Alternativi | ${m.n} risers | Rise ${fmt(m.rise,'mm',3)} mm | Going ${fmt(m.going,'mm',3)} mm`,m.footprintX/2,-bp.maxY-200,90);
 text('Layout geometry only. Headroom, structure and local code not checked.',m.footprintX/2,-bp.maxY-370,80);
 p(0,'ENDSEC');p(0,'EOF');
 return pairs.join('\r\n')+'\r\n';
}

function makePDF(s,m,drawings){
 const commands=[];
 const command=s=>commands.push(s);
 const pdfText=s=>ascii(s).replace(/([\\()])/g,'\\$1');
 const text=(s,x,y,size=9,gray=.16,align='left')=>{
  s=ascii(s);if(align==='center')x-=s.length*size*.255;
  command(`BT /F1 ${number(size)} Tf ${gray} g 1 0 0 1 ${number(x)} ${number(y)} Tm (${pdfText(s)}) Tj ET`);
 };
 const line=(x1,y1,x2,y2,gray=.8)=>command(`${gray} G 0.5 w [] 0 d ${x1} ${y1} m ${x2} ${y2} l S`);
 text('studio alternativi',34,558,15);text('resources for architects',34,543,7,.48);
 text('Stair calculator',706,558,15);
 line(34,526,808,526);
 const shape={straight:'Straight',l:'L-shaped',u:'U-shaped'}[s.shape];
 text(`${shape} stair   /   Floor-to-floor ${fmt(s.height,s.unit)} ${s.unit}   /   Flight width ${fmt(s.width,s.unit)} ${s.unit}`,34,508,10);
 text(`Dimensions in ${s.unit}. Drawing fitted to page, not to scale. DXF geometry is in millimetres.`,34,490,8,.45);
 const panels=[{x:34,w:350,entities:drawings.plan,title:'PLAN'},{x:410,w:398,entities:drawings.section,title:m.n2?'UNFOLDED SECTION':'SECTION'}];
 for(const panel of panels){
  text(panel.title,panel.x,463,8,.4);const b=bounds(panel.entities),h=268,w=panel.w-12;
  const scale=Math.min(w/(b.maxX-b.minX),h/(b.maxY-b.minY));
  const ox=panel.x+panel.w/2-(b.minX+b.maxX)/2*scale,oy=306+(b.minY+b.maxY)/2*scale;
  const point=(x,y)=>`${number(ox+x*scale)} ${number(oy-y*scale)}`;
  for(const e of panel.entities){
   if(e.type==='text'){text(e.text,ox+e.x*scale,oy-e.y*scale,Math.max(4.2,e.size*scale),.38,'center');continue;}
   const gray=e.layer==='DIM'?.55:e.layer==='AVAILABLE'?.58:e.layer==='PITCH'?.67:.16;
   command(`${gray} G ${e.layer==='UP'?.85:.55} w ${e.layer==='AVAILABLE'?'[4 3]':e.layer==='PITCH'?'[2 2]':'[]'} 0 d`);
   if(e.fill)command('.943 g');
   command(e.pts.map((p,i)=>`${point(...p)} ${i?'l':'m'}`).join(' ')+(e.fill?' B':' S'));
  }
 }
 line(34,157,808,157);
 const stats=[['RISERS',`${m.n} (${m.treads} treads)`],['RISE',`${fmt(m.rise,s.unit)} ${s.unit}`],['GOING',`${fmt(m.going,s.unit)} ${s.unit}`],['PITCH',`${m.angle.toFixed(1)} deg`],['LANDING DEPTH',m.n2?`${fmt(m.landing,s.unit)} ${s.unit}`:'None'],['FOOTPRINT / L x W',`${fmt(m.footprintY,s.unit)} x ${fmt(m.footprintX,s.unit)} ${s.unit}`]];
 stats.forEach(([label,value],i)=>{const x=34+i*129;text(label,x,139,6.5,.45);text(value,x,122,i===5?9:11);});
 let fitText='Footprint excludes walls, handrails and clear arrival space at the top and bottom.';
 if(m.excess)fitText=m.excess.length||m.excess.width?`Available footprint exceeded by ${fmt(m.excess.length,s.unit)} ${s.unit} in length and ${fmt(m.excess.width,s.unit)} ${s.unit} in width.`:'Fits the entered footprint. Walls, handrails and arrival space are not included.';
 text(fitText,34,99,8,.4);
 text(`Design assumptions: target rise 175 mm. Automatic going = 630 mm - 2 x rise. Current 2R + G = ${fmt(m.proportion,'mm')} mm.`,34,79,8,.4);
 text('Layout geometry only. Headroom, structure, handrails, guards, access and local code compliance are not checked.',34,62,8,.4);
 line(34,47,808,47);text('studioalternativi.com',34,31,8,.4);text(m.n2?`Flight split: ${m.n1} + ${m.n2} risers`:'Single flight',688,31,8,.4);
 const stream=commands.join('\n');
 const objects=[
  '<< /Type /Catalog /Pages 2 0 R >>',
  '<< /Type /Pages /Kids [3 0 R] /Count 1 >>',
  '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 842 595] /Resources << /Font << /F1 4 0 R >> >> /Contents 5 0 R >>',
  '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>',
  `<< /Length ${stream.length} >>\nstream\n${stream}\nendstream`,
  '<< /Title (Stair calculator - Studio Alternativi) /Creator (Studio Alternativi) >>'
 ];
 let pdf='%PDF-1.4\n',offsets=[0];
 objects.forEach((o,i)=>{offsets.push(pdf.length);pdf+=`${i+1} 0 obj\n${o}\nendobj\n`;});
 const xref=pdf.length;pdf+=`xref\n0 ${objects.length+1}\n0000000000 65535 f \n`;
 for(const offset of offsets.slice(1))pdf+=`${String(offset).padStart(10,'0')} 00000 n \n`;
 pdf+=`trailer\n<< /Size ${objects.length+1} /Root 1 0 R /Info 6 0 R >>\nstartxref\n${xref}\n%%EOF\n`;
 return new TextEncoder().encode(pdf);
}


const $=id=>root.querySelector('[data-control="'+id+'"]'),all=selector=>[...root.querySelectorAll(selector)],KEY='sa-stair-calculator-v1';
let s={...DEFAULT},view='plan',storage=true;
try{
 const saved=JSON.parse(localStorage.getItem(KEY)||'null');
 if(saved&&typeof saved==='object'){
  for(const key of Object.keys(DEFAULT)){
   const value=saved[key];
   if(['unit','shape'].includes(key)){if((key==='unit'?['mm','cm','in']:['straight','l','u']).includes(value))s[key]=value;}
   else if(typeof DEFAULT[key]==='boolean'){if(typeof value==='boolean')s[key]=value;}
   else if(Number.isFinite(value)||(DEFAULT[key]===null&&value===null))s[key]=value;
  }
  if(calculate(s).errors.length)s={...DEFAULT};
 }
}catch{storage=false;}

const dimensionFields=['height','width','going','landing','gap','availableLength','availableWidth'];
const safeText=(id,value)=>{$(id).textContent=value;};
function save(){
 if(calculate(s).errors.length)return;
 try{localStorage.setItem(KEY,JSON.stringify(s));storage=true;}catch{storage=false;}
 safeText('saved',storage?'Saved in this browser':'Current session only');
 translateRendered();
}
function inputValue(id,value,force=false){
 if(force||document.activeElement!==$(id))$(id).value=Number.isFinite(value)?Number(value.toFixed(5)):'';
}
function renderBase(force=false){
 const m=calculate(s),valid=m.errors.length===0;
 root.dataset.shape=s.shape;
 all('[data-unit]').forEach(b=>{b.classList.toggle('active',b.dataset.unit===s.unit);b.setAttribute('aria-pressed',String(b.dataset.unit===s.unit));});
 all('[data-shape]').forEach(b=>{b.classList.toggle('active',b.dataset.shape===s.shape);b.setAttribute('aria-pressed',String(b.dataset.shape===s.shape));});
 all('[data-view]').forEach(b=>{b.classList.toggle('active',b.dataset.view===view);b.setAttribute('aria-selected',String(b.dataset.view===view));});
 all('.unit,.unit-hint').forEach(e=>e.textContent=s.unit);
 const autoN=s.n??suggestCount(s.height,s.shape),autoRise=s.height/autoN;
 for(const id of dimensionFields){const v=s[id]??(id==='going'?630-2*autoRise:id==='landing'?s.width:NaN);inputValue(id,v/FACTOR[s.unit],force);$(id).step='any';}
 inputValue('n',autoN,force);$('n').min=s.shape==='straight'?2:4;
 for(const [id,key] of [['auto-count','n'],['auto-going','going'],['auto-landing','landing']]){
  $(id).textContent=s[key]===null?'Auto ✓':'Use auto';$(id).setAttribute('aria-pressed',String(s[key]===null));
 }
 $('fit').checked=s.fit;$('availableLength').disabled=!s.fit;$('availableWidth').disabled=!s.fit;
 $('flip-top').hidden=s.shape==='straight';$('flip-top').setAttribute('aria-pressed',String(s.flip));$('flip').setAttribute('aria-pressed',String(s.flip));
 $('pdf').disabled=!valid;$('dxf').disabled=!valid;
 $('invalid').hidden=valid;
 $('invalid').replaceChildren(...m.errors.map(error=>{const p=document.createElement('p');p.textContent=error;return p;}));
 safeText('drawing-unit',`dimensions in ${s.unit}`);
 safeText('drawing-caption',`${({straight:'straight stair',l:'l-shaped stair',u:'u-shaped stair'})[s.shape]} / ${view==='section'&&s.shape!=='straight'?'unfolded section':view}`);
 safeText('saved',storage?'Saved in this browser':'Current session only');
 if(!valid){
  $('drawing').replaceChildren();$('options').replaceChildren();$('fit-status').hidden=true;
  ['result-n','result-rise','result-going','result-angle','result-landing','result-footprint'].forEach(id=>safeText(id,'-'));
  ['result-treads','landing-note','footprint-unit','notice'].forEach(id=>safeText(id,''));
  $('split-less').disabled=true;$('split-more').disabled=true;safeText('split-value','-');return;
 }
 safeText('split-value',`${m.n1} + ${m.n2}`);$('split-less').disabled=m.n1<=2;$('split-more').disabled=m.n2<=2;
 const label=(id,value,unit)=>{const em=document.createElement('em');em.textContent=unit;$(id).replaceChildren(document.createTextNode(`${value} `),em);};
 safeText('result-n',m.n);safeText('result-treads',`${m.treads} treads${m.n2?' + landing':''}`);
 label('result-rise',fmt(m.rise,s.unit),s.unit);label('result-going',fmt(m.going,s.unit),s.unit);
 safeText('result-angle',`${m.angle.toFixed(1)}°`);
 if(m.n2)label('result-landing',fmt(m.landing,s.unit),s.unit);else safeText('result-landing','None');
 safeText('landing-note',m.n2?'intermediate landing depth':'single flight');
 safeText('result-footprint',`${fmt(m.footprintY,s.unit)} × ${fmt(m.footprintX,s.unit)}`);
 safeText('footprint-unit',`length × width, ${s.unit}`);
 const drawings=geometry(s,m);$('drawing').innerHTML=renderSVG(drawings[view],`${s.shape==='straight'?'Straight':s.shape.toUpperCase()+'-shaped'} stair ${view}`);
 $('fit-status').hidden=!s.fit;
 if(s.fit){
  const over=m.excess.length>0||m.excess.width>0;
  $('fit-status').dataset.over=String(over);
  const excess=[];if(m.excess.length>0)excess.push(`${fmt(m.excess.length,s.unit)} ${s.unit} too long`);if(m.excess.width>0)excess.push(`${fmt(m.excess.width,s.unit)} ${s.unit} too wide`);
  safeText('fit-status',over?`Doesn’t fit. ${excess.join(' · ')}.`:'Fits the entered footprint. Allow extra for walls and arrival space.');
 }
 $('options').replaceChildren(...alternatives(s).filter(option=>!option.errors.length).map(option=>{
  const button=document.createElement('button');button.classList.toggle('active',option.selected);button.setAttribute('aria-pressed',String(option.selected));
  const title=document.createElement('strong');title.textContent=`${option.n} risers`;
  const rise=document.createElement('span');rise.textContent=`rise ${fmt(option.rise,s.unit)} ${s.unit}`;
  const going=document.createElement('span');going.textContent=`going ${fmt(option.going,s.unit)} ${s.unit}`;
  const foot=document.createElement('span');foot.textContent=`${fmt(option.footprintY,s.unit)} × ${fmt(option.footprintX,s.unit)} ${s.unit}`;
  button.append(title,rise,going,foot);
  if(s.fit){const fit=document.createElement('span');fit.textContent=option.excess.length||option.excess.width?'exceeds footprint':'fits footprint';button.append(fit);}
  if(option.selected){const dot=document.createElement('span');dot.className='dot';dot.textContent='•';dot.setAttribute('aria-hidden','true');button.append(dot);}
  button.addEventListener('click',()=>{s.n=option.n;s.split=null;update(true);});return button;
 }));
 safeText('notice',m.warnings.length?`${m.warnings.join(' ')} Design guidance only.`:'');
}
function update(force=false){render(force);save();}
dimensionFields.forEach(id=>{
 $(id).addEventListener('input',()=>{s[id]=$(id).value===''?NaN:Number($(id).value)*FACTOR[s.unit];if(id==='height'&&s.n===null&&s.split!==null&&Number.isFinite(s.height))s.split=Math.max(2,Math.min(s.split,suggestCount(s.height,s.shape)-2));update();});
 $(id).addEventListener('blur',()=>render(true));
});
$('n').addEventListener('input',()=>{s.n=$('n').value===''?NaN:Number($('n').value);s.split=null;update();});
$('n').addEventListener('blur',()=>render(true));
all('[data-unit]').forEach(b=>b.addEventListener('click',()=>{s.unit=b.dataset.unit;update(true);}));
all('[data-shape]').forEach(b=>b.addEventListener('click',()=>{s.shape=b.dataset.shape;s.split=null;if(s.shape!=='straight'&&s.n!==null&&s.n<4)s.n=null;update(true);}));
all('[data-view]').forEach(b=>b.addEventListener('click',()=>{view=b.dataset.view;render();}));

all('[data-view]').forEach((b,i,tabs)=>b.addEventListener('keydown',event=>{if(['ArrowLeft','ArrowRight','Home','End'].includes(event.key)){event.preventDefault();const next=event.key==='Home'?0:event.key==='End'?1:1-i;tabs[next].focus();tabs[next].click();}}));
for(const [id,key] of [['auto-count','n'],['auto-going','going'],['auto-landing','landing']])$(id).addEventListener('click',()=>{s[key]=null;if(key==='n')s.split=null;update(true);});
for(const [id,delta] of [['split-less',-1],['split-more',1]])$(id).addEventListener('click',()=>{const m=calculate(s);if(!m.errors.length){s.split=m.n1+delta;update(true);}});
for(const id of ['flip','flip-top'])$(id).addEventListener('click',()=>{s.flip=!s.flip;update();});
$('fit').addEventListener('change',()=>{s.fit=$('fit').checked;update();});
$('reset').addEventListener('click',()=>{s={...DEFAULT};view='plan';$('adjust').open=false;$('fit-details').open=false;update(true);});
function download(type){
 const m=calculate(s);if(m.errors.length)return;
 try{
  const drawings=geometry(s,m),data=type==='pdf'?makePDF(s,m,drawings):makeDXF(s,m,drawings);
  const blob=new Blob([data],{type:type==='pdf'?'application/pdf':'application/dxf'}),url=URL.createObjectURL(blob),a=document.createElement('a');
  a.href=url;a.download=`Studio-Alternativi-${s.shape}-stair-${m.n}-risers.${type}`;document.body.append(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),30000);
  safeText('notice',trText(`${type.toUpperCase()} downloaded. ${type==='dxf'?'Drawing units: millimetres, 1:1.':'Sheet fitted to page, not to scale.'}`));
 }catch{safeText('notice',trText('The download could not be created. Please try again.'));}
}
$('pdf').addEventListener('click',()=>download('pdf'));$('dxf').addEventListener('click',()=>download('dxf'));
if(s.fit)$('fit-details').open=true;
update(true);

}
if(!customElements.get('sa-stair-calculator'))customElements.define('sa-stair-calculator',class extends HTMLElement{connectedCallback(){queueMicrotask(()=>{if(this.querySelector('[data-translations]'))initialize(this);});}});
})();

  } catch(e) { console.error(e); }
})();
})();
